import React, { useState, useEffect } from "react";
import { Star, ExternalLink } from "lucide-react";
import { testimonials } from "../data/mock";
import "../styles/Testimonials.css";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Testimonials = () => {
  const [reviews, setReviews] = useState(testimonials);
  const [rating, setRating] = useState(5.0);
  const [reviewCount, setReviewCount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(`${API_URL}/api/reviews`);
        const data = await response.json();

        if (data.success && data.data) {
          // Transform Google reviews to match our display format
          const googleReviews = data.data.reviews.map((review) => ({
            id: review.id,
            name: review.author_attribution.display_name,
            treatment: "Google Review",
            text: review.text,
            rating: review.rating,
            photo_uri: review.author_attribution.photo_uri,
            uri: review.author_attribution.uri,
          }));

          if (googleReviews.length > 0) {
            setReviews(googleReviews.slice(0, 6)); // Show up to 6 reviews
          }

          if (data.data.rating) {
            setRating(data.data.rating);
          }

          if (data.data.user_rating_count) {
            setReviewCount(data.data.user_rating_count);
          }
        }
      } catch (error) {
        console.error("Failed to fetch Google reviews:", error);
        // Keep using mock data if API fails
      } finally {
        setIsLoading(false);
      }
    };

    fetchReviews();
  }, []);

  const openGoogleReviews = () => {
    window.open("https://share.google/SndUyIeDae1IEfzXT", "_blank");
  };

  return (
    <section id="testimonials" className="testimonials-section section-padding-small">
      <div className="container">
        <div className="testimonials-header">
          <span className="body-small section-label">Testimonials</span>
          <h2 className="hero-medium">Client Experiences</h2>
          <p className="body-large">
            Hear from those who've experienced the Aura Aesthetics difference
          </p>
          <div className="google-rating-badge">
            <div className="rating-stars">
              {[...Array(5)].map((_, i) => (
                <Star 
                  key={i} 
                  size={20} 
                  fill={i < Math.floor(rating) ? "var(--gold-primary)" : "transparent"} 
                  color="var(--gold-primary)" 
                />
              ))}
            </div>
            <p className="body-regular">
              Rated {rating.toFixed(1)} on Google Reviews (10 reviews)
            </p>
          </div>
        </div>
        {isLoading ? (
          <div className="testimonials-loading">
            <p className="body-regular">Loading reviews...</p>
          </div>
        ) : (
          <div className="testimonials-grid">
            {reviews.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="quote-icon">"</div>
                <p className="body-large testimonial-text">{testimonial.text}</p>
                <div className="testimonial-footer">
                  <div>
                    <p className="heading-3">{testimonial.name}</p>
                    <p className="body-small">{testimonial.treatment}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="testimonials-cta">
          <h3 className="heading-2">Share Your Experience</h3>
          <p className="body-large">
            Had a wonderful experience? We'd love to hear from you!
          </p>
          <button onClick={openGoogleReviews} className="btn-primary">
            Leave a Google Review <ExternalLink size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
